import {
  isFieldPartIdentifier,
  isFieldGroupPartIdentifier,
  isSectionPartIdentifier,
  isSelectOptionPartIdentifier,
  isSubsectionPartIdentifier,
  PartIdentifier,
} from '@zinnia/form-engine-sdk';

export function isPartIdentifierTheSameOrAChild(
  potentialChildPartIdentifier: PartIdentifier,
  potentialParentPartIdentifier: PartIdentifier,
): boolean {
  if (
    isSectionPartIdentifier(potentialParentPartIdentifier) &&
    (isSectionPartIdentifier(potentialChildPartIdentifier) ||
      isSubsectionPartIdentifier(potentialChildPartIdentifier) ||
      isFieldGroupPartIdentifier(potentialChildPartIdentifier) ||
      isFieldPartIdentifier(potentialChildPartIdentifier) ||
      isSelectOptionPartIdentifier(potentialChildPartIdentifier))
  ) {
    return potentialParentPartIdentifier.sectionPartName === potentialChildPartIdentifier.sectionPartName;
  }
  if (
    isSubsectionPartIdentifier(potentialParentPartIdentifier) &&
    (isSubsectionPartIdentifier(potentialChildPartIdentifier) ||
      isFieldGroupPartIdentifier(potentialChildPartIdentifier) ||
      isFieldPartIdentifier(potentialChildPartIdentifier) ||
      isSelectOptionPartIdentifier(potentialChildPartIdentifier))
  ) {
    return (
      potentialParentPartIdentifier.sectionPartName === potentialChildPartIdentifier.sectionPartName &&
      potentialParentPartIdentifier.subsectionPartName === potentialChildPartIdentifier.subsectionPartName
    );
  }
  if (
    isFieldGroupPartIdentifier(potentialParentPartIdentifier) &&
    (isFieldGroupPartIdentifier(potentialChildPartIdentifier) ||
      isFieldPartIdentifier(potentialChildPartIdentifier) ||
      isSelectOptionPartIdentifier(potentialChildPartIdentifier))
  ) {
    return (
      potentialParentPartIdentifier.sectionPartName === potentialChildPartIdentifier.sectionPartName &&
      potentialParentPartIdentifier.subsectionPartName === potentialChildPartIdentifier.subsectionPartName &&
      potentialParentPartIdentifier.fieldGroupPartName === potentialChildPartIdentifier.fieldGroupPartName
    );
  }
  if (
    isFieldPartIdentifier(potentialParentPartIdentifier) &&
    (isFieldPartIdentifier(potentialChildPartIdentifier) || isSelectOptionPartIdentifier(potentialChildPartIdentifier))
  ) {
    return (
      potentialParentPartIdentifier.sectionPartName === potentialChildPartIdentifier.sectionPartName &&
      potentialParentPartIdentifier.subsectionPartName === potentialChildPartIdentifier.subsectionPartName &&
      potentialParentPartIdentifier.fieldGroupPartName === potentialChildPartIdentifier.fieldGroupPartName &&
      potentialParentPartIdentifier.fieldPartName === potentialChildPartIdentifier.fieldPartName
    );
  }
  if (
    isSelectOptionPartIdentifier(potentialChildPartIdentifier) &&
    isSelectOptionPartIdentifier(potentialParentPartIdentifier)
  ) {
    return (
      potentialParentPartIdentifier.sectionPartName === potentialChildPartIdentifier.sectionPartName &&
      potentialParentPartIdentifier.subsectionPartName === potentialChildPartIdentifier.subsectionPartName &&
      potentialParentPartIdentifier.fieldGroupPartName === potentialChildPartIdentifier.fieldGroupPartName &&
      potentialParentPartIdentifier.fieldPartName === potentialChildPartIdentifier.fieldPartName &&
      potentialParentPartIdentifier.selectOptionValue === potentialChildPartIdentifier.selectOptionValue
    );
  }
  return false;
}
